import { render, staticRenderFns } from "./TouchpointBrickSettings.vue?vue&type=template&id=696cba93&scoped=true&"
import script from "./TouchpointBrickSettings.vue?vue&type=script&lang=js&"
export * from "./TouchpointBrickSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696cba93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('696cba93')) {
      api.createRecord('696cba93', component.options)
    } else {
      api.reload('696cba93', component.options)
    }
    module.hot.accept("./TouchpointBrickSettings.vue?vue&type=template&id=696cba93&scoped=true&", function () {
      api.rerender('696cba93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Settings/Touchpoint/TouchpointBrickSettings.vue"
export default component.exports